import { ReactNode, useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import { ErrorReference, reportWithReference } from '../../utils/error-reference';
import { ErrorFallbackMessage } from '../ErrorBoundary/ErrorFallbackMessage';
import './RouteErrorFallback.scss';

// Render errors inside the router are caught by React Router before the ErrorBoundary in main.tsx,
// so without this route-level element users get the framework's default error screen and no
// reference ID. Uses the same message component as the ErrorBoundary default fallback.
export const RouteErrorFallback = (): ReactNode => {
  const error = useRouteError();
  const [reference, setReference] = useState<ErrorReference>();

  useEffect(() => {
    console.error(error);
    setReference(reportWithReference(error, 'RouteErrorFallback'));
  }, [error]);

  return <ErrorFallbackMessage className='route-error-fallback' reference={reference} />;
};
